export default "__VITE_ASSET__CmHpEMki__"